import { noop } from "@common/helpers/function";
import { InvoiceStatus as InvoiceStatusEnum } from "@common/types/invoice";
import { InvoiceStatus } from "@components/invoices/InvoiceStatus";
import {
    FilterMultiselect,
    FilterMultiselectOption,
    FilterMultiselectValue,
} from "@components/pageHeader/filters/FilterMultiselect/FilterMultiselect";
import { BaseFilterProps } from "@components/pageHeader/filters/lib";

const INVOICE_STATUS_VALUES = Object.values(InvoiceStatusEnum);

function isInvoiceStatus(
    value: FilterMultiselectValue,
): value is InvoiceStatusEnum {
    return INVOICE_STATUS_VALUES.some((status) => status === value);
}

export const BillableExpenseInvoiceStatusFilter: React.FC<BaseFilterProps> = ({
    filters,
    onChange,
}) => {
    const options: FilterMultiselectOption[] = INVOICE_STATUS_VALUES.map(
        (status) => ({
            value: status,
            label: <InvoiceStatus status={status} showText />,
            searchableLabel: status,
        }),
    );

    const statuses = filters.billableExpenseInvoiceStatuses ?? [];

    return (
        <FilterMultiselect
            inDropdown={false}
            searchable={false}
            options={options}
            value={statuses}
            onChange={(val) => {
                onChange({
                    billableExpenseInvoiceStatuses: val.filter(isInvoiceStatus),
                });
            }}
            name="billableExpenseInvoiceStatuses"
            onBlur={noop}
        />
    );
};
